import { getApi } from '@BUP/services/Axios'
import { downloadCsv } from '@BUP/utils/csv'
import { useCourseAssignmentMutation } from './useCourseAssignmentMutation'

const fetchAndDownloadLegacyExport = async (periodId) => {
  const client = await getApi('schools', { authenticated: true, version: 5 })
  const { data } = await client.get(`/current-organization/course-assignment/periods/${periodId}/legacy-export`)

  downloadCsv('01 Eleccion companeros.csv', data.preferencesCsv)
  downloadCsv('02 Evaluacion profesores.csv', data.evaluationsCsv)
  downloadCsv('03 Casos especiales.csv', data.exclusionsCsv)

  return data
}

export const useDownloadLegacyExport = () => {
  return useCourseAssignmentMutation({
    mutationFn: fetchAndDownloadLegacyExport,
    hookName: 'useDownloadLegacyExport',
    errorMessage: 'Error downloading legacy course-generator export'
  })
}
